<template>
  <div class="page">
    <!-- App 内透明导航栏，滚动后渐变为白色（仅 App 显示） -->
    <AppNavBar v-if="isApp" :options="navOptions" title="邀好友·开业转介" :placeholder="true" :z-index="10" />
    <!-- 主视觉（含开业时间横幅，静态视觉图） -->
    <img class="hero" src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-o-member-kv"
      alt="" />
    <!-- 我的邀请 -->
    <div class="section-title invite-title">
      <span class="line"></span>
      <span class="title-text">我的邀请</span>
      <span class="line"></span>
    </div>
    <div class="stat-card">
      <div class="stat-row">
        <div class="stat-item">
          <span class="stat-num">{{ invitedCount }}</span>
          <span class="stat-label">已邀请(人)</span>
        </div>
        <span class="stat-divider"></span>
        <div class="stat-item">
          <span class="stat-num">{{ activatedCount }}</span>
          <span class="stat-label">邀请成功(人)</span>
        </div>
      </div>
      <div class="detail-btn" @click="showDetail = true"> 查看邀请明细 </div>
    </div>

    <!-- 邀请好友按钮 -->
    <img class="invite-btn" @click="onInvite"
      src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-o-member-button" alt="" />

    <!-- 活动规则 -->
    <div class="section-title rules-title">
      <span class="line"></span>
      <span class="title-text">活动规则</span>
      <span class="line"></span>
    </div>
    <div id="activity-rules" class="rule-card">
      <img class="rule-img" src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-rule"
        alt="" />
    </div>
    <img class="bottom-band"
      src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-btm-logo" alt="" />

    <!-- 右上角固定活动规则入口 -->
    <img class="fixed-rule"
      src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-rule-btn" alt=""
      @click="scrollToRules" />

    <InviteDetailPopup v-model="showDetail" :invited-list="invitedList" :activated-list="activatedList" />
  </div>
</template>
<script>
import InviteDetailPopup from './ponents/InviteDetailPopup.vue'
import AppNavBar from '@/components/app/nav-bar/index.vue'
const SHARE_THUMBNAIL =
  'https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-30-zxg-invite-activity-share-image'
export default {
  components: { InviteDetailPopup, AppNavBar },
  data() {
    return {
      navOptions: {
        // 初始透明，滚动后渐变为白色（参考 camp-introduce-common/old-member.vue）
        barBackgroundColor: 'rgba(255,255,255,1)',
        color: '#000'
      },
      isApp: false, // 仅 App 环境显示透明导航栏
      invitedCount: 0, // 已邀请人数
      activatedCount: 0, // 已激活人数
      invitedList: [], // 已邀请用户
      activatedList: [], // 已激活用户
      showDetail: false,
      loaded: false, // 是否已加载过数据（userId 就绪后只请求一次）
      apiNickname: '', // member 接口返回的会员昵称（分享标题用）
      referrerId: 0 // member 接口返回的转介人 user_id（埋点与分享用）
    }
  },
  computed: {
    // 当前登录老会员用户中心 ID（App.vue 全局 getUserData 异步填充 store，登录就绪后才有值）
    userId() {
      const info = this.$store.state.userInfo
      return (info && info.user && info.user.uid) || 0
    },
    // 用户昵称（分享标题用，取 member 接口返回的 user.nickname）
    userName() {
      return this.apiNickname || '好友'
    },
    // 埋点携带的转介人 user_id：优先接口返回值，没有则回退到登录用户 uid
    referrerIdForTrack() {
      return this.referrerId || this.userId || 0
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler(val) {
        if (val && !this.loaded) {
          this.loaded = true
          this.getSummary()
          this.getDetail()
        }
      }
    }
  },
  mounted() {
    this.isApp = this.$betterwe.isApp()
    // 老会员活动页曝光埋点需拿到转介人 user_id（来自 /api/referral/member 接口），因此放到 getSummary 成功回调里
    // this.addScroll()
  },
  beforeDestroy() {
    // this.removeScroll()
  },
  methods: {
    // 老会员信息+转介资格（含邀请统计摘要）
    getSummary() {
      this.$http
        .postArena('/api/referral/member', { user_id: this.userId })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            const summary = res.data.summary || {}
            this.invitedCount = summary.total || 0
            this.activatedCount = summary.success || 0
            const apiUser = res.data.user || {}
            this.apiNickname = apiUser.nickname || ''
            // 缓存转介人 user_id（埋点携带）
            this.referrerId = apiUser.user_id || 0
            // 老会员活动页曝光埋点（接口返回 user_id 后再发）
            this.$http.bindH5UMA(
              'zxg_referral_202610_member_page_view',
              this.referrerIdForTrack
            )
          } else {
            // 转介资格校验失败：确认弹窗提示，用户确认后返回
            this.$dialog
              .alert({ message: res.msg || '活动信息获取失败' })
              .then(() => {
                this.$http.appBack()
              })
          }
        })
        .catch(() => { })
    },
    // 邀请明细（页面拉取后按"是否转介成功"拆分传给弹窗组件）
    getDetail() {
      this.$http
        .getArena('/api/referral/invitations', { user_id: this.userId })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            const list = (res.data && res.data.list) || []
            const toItem = (i) => ({
              avatar: i.friend && i.friend.avatar || '',
              nickname: i.friend && i.friend.nickname,
              phone: i.friend && i.friend.phone_masked
            })
            this.invitedList = list.filter((i) => !i.success).map(toItem)
            this.activatedList = list.filter((i) => i.success).map(toItem)
          }
        })
        .catch(() => { })
    },
    // 邀请好友：先生成转介唯一码，成功后再调原生分享 H5 卡片
    onInvite() {
      // 「邀请好友」按钮点击埋点（携带转介人 user_id）
      this.$http.bindH5UMA('zxg_referral_202610_invite_btn_click', this.referrerIdForTrack)
      if (!this.userId) {
        this.$toast('请先登录后再邀请好友')
        return
      }
      if (!this.$betterwe.isApp()) {
        this.$toast('请点击右上角菜单分享给好友')
        return
      }
      const loading = this.$toast.loading({
        message: '生成邀请中...',
        forbidClick: true,
        duration: 0
      })
      this.$http
        .postArena('/api/referral/code', { user_id: this.userId, scene: 1 })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            const { unique_code: uniqueCode } = res.data
            // 分享链接仅携带 code 参数；后端未配置分享前缀时前端自行拼装
            const url = `${location.origin}/zx-referral/new-member?code=${uniqueCode}&coach_id=${this.$route.query.coach_id || ''}`
            this.$betterwe.onAppShare({
              shareType: 1, // 1 微信好友 2 微信朋友圈
              contentType: 'url',
              shareData: {
                data: url,
                type: 'url',
                desc: '领卡得3天场地体验卡',
                title: `好友邀请你一起来星球综训馆免费体验`,
                thumbnail: SHARE_THUMBNAIL
              }
            })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('网络异常，请稍后重试')
        })
        .finally(() => {
          loading.clear()
        })
    },
    // 滚动到活动规则
    scrollToRules() {
      const el = document.getElementById('activity-rules')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // 透明导航栏：滚动到 100px 内按比例从透明渐变为白色
    bindScroll() {
      const maxHeight = 100
      let scroll =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.navOptions.barBackgroundColor =
          'rgba(255,255,255,' + (scroll / maxHeight).toFixed(2) + ')'
      } else {
        this.navOptions.barBackgroundColor = 'rgba(255,255,255,1)'
      }
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  background: rgba(255, 100, 25, 1);
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.hero {
  width: 100%;
  height: 387px;
  object-fit: contain;
}

.bottom-band {
  margin: 18px auto 47px;
  display: block;
  width: 147px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;

  .line {
    width: 31px;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
  }

  .title-text {
    margin: 0 14px;
    font-size: 20px;
    font-family: MiSans-Demibold, MiSans;
    color: #fff;
    text-align: center;
    line-height: 27px;
  }
}

.invite-title {
  margin-top: 20px;
}

.rules-title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-card {
  width: 343px;
  margin: 10px auto 0;
  background: linear-gradient(180deg, #fff1b6 0%, #ffffff 55%, #ffffff 100%);
  border-radius: 8px;
  padding: 12px 58px 16px;
  box-sizing: border-box;

  .stat-row {
    display: flex;
    justify-content: space-between;
    width: 227px;
    margin: 0 auto;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;

    .stat-num {
      font-weight: 600;
      font-size: 28px;
      font-family: MiSans-Demibold, MiSans;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      line-height: 37px;
    }

    .stat-label {
      margin-top: 2px;
      font-size: 12px;
      font-family: MiSans-Regular, MiSans;
      color: rgba(0, 0, 0, 0.5);
      line-height: 18px;
    }
  }

  .stat-divider {
    width: 1px;
    height: 46px;
    background-color: rgba(0, 0, 0, 0.05);
    margin: 5px 0 6px;
  }

  .detail-btn {
    width: 141px;
    margin: 16px auto 0;
    border: 1px solid rgba(255, 100, 25, 1);
    border-radius: 16px;
    padding: 6px 0;
    box-sizing: border-box;
    font-size: 13px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 100, 25, 1);
    text-align: center;
    line-height: 18px;

    &:active {
      opacity: 0.6;
    }
  }
}

.invite-btn {
  width: 375px;
  height: 98px;
}

.rule-card {
  width: 343px;
  margin: 7px auto 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .rule-img {
    width: 100%;
  }
}

.fixed-rule {
  position: fixed;
  right: 0;
  top: 159px;
  width: 28px;
  height: 88px;
  z-index: 10;

  .fixed-icon {
    display: block;
    width: 14px;
    height: 13px;
  }

  .fixed-text {
    display: block;
    width: 13px;
    margin: 5px 0 0 1px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 14px;
  }
}
</style>
